import { Box, Flex, Button } from '@indeed/ifl-components'
import React, { useState } from 'react'
import { updateAgencyBookings } from 'syft-acp-core/actions/agency-bookings'
import { useDispatch } from 'react-redux'
import { Close, Plus } from '@indeed/ifl-icons'
import { DataDatetime } from 'syft-acp-core/components/EditableTable'

type ListingAgencyMealBreaksProps = {
  attr: string
  disabled: boolean
  shiftBooking: {
    id: number
    shiftID: number
    timezone: string
    allocated_meal_durations: number[]
    meal_times: {
      meal_id: string | null
      meal_clock_in: string | null
      meal_clock_out: string | null
    }[]
  }
}

export const ListingAgencyMealBreaks = ({ attr, shiftBooking, disabled }: ListingAgencyMealBreaksProps) => {
  const dispatch = useDispatch()
  const { meal_times: mealTimes, allocated_meal_durations, timezone } = shiftBooking
  const [mealAllocation, setMealAllocation] = useState(allocated_meal_durations?.length)

  const allocatedMeals = Array(mealAllocation).fill(1)
  const lastIndex = allocatedMeals?.length - 1

  const handleChangeMealBreak =
    (index: number, name: 'meal_clock_in' | 'meal_clock_out') => (value: string) => {
      dispatch(
        updateAgencyBookings({
          attr: `${attr}[${index}].${name}`,
          val: value,
          id: shiftBooking.id,
          shiftID: shiftBooking.shiftID,
        }),
      )
    }

  const handleDeleteMealBreak = (index: number) => () => {
    dispatch(
      updateAgencyBookings({
        attr: `${attr}[${index}].meal_clock_in`,
        val: null,
        id: shiftBooking.id,
        shiftID: shiftBooking.shiftID,
      }),
    )

    dispatch(
      updateAgencyBookings({
        attr: `${attr}[${index}].meal_clock_out`,
        val: null,
        id: shiftBooking.id,
        shiftID: shiftBooking.shiftID,
      }),
    )
  }

  const handleAddMealBreak = (totalBreaks: number) => () => {
    setMealAllocation(totalBreaks)
  }

  return (
    <Box>
      {allocatedMeals?.map((_, index) => {
        const mealBreak = mealTimes?.[index]

        return (
          <Flex key={mealBreak?.meal_id || `meal-${index}`} sx={{ alignItems: 'flex-start', gap: 1, p: 1 }}>
            <Flex
              sx={{
                flexDirection: 'column',
                gap: 1,
                minWidth: '228px',
                pb: lastIndex === index ? 0 : 2,
                borderBottom: lastIndex === index ? 'none' : '1px solid #CCC',
              }}
            >
              <DataDatetime
                value={mealBreak?.meal_clock_in ?? ''}
                onChange={handleChangeMealBreak(index, 'meal_clock_in')}
                disabled={disabled}
                parameters={{ timeZone: timezone }}
                showTimezone={false}
                editable
                data={{}}
              />

              <DataDatetime
                value={mealBreak?.meal_clock_out ?? ''}
                onChange={handleChangeMealBreak(index, 'meal_clock_out')}
                disabled={disabled}
                parameters={{ timeZone: timezone }}
                showTimezone={false}
                editable
                data={{}}
              />
            </Flex>

            <Button
              variant="text"
              iconOnly
              size="sm"
              type="button"
              onClick={handleDeleteMealBreak(index)}
              disabled={disabled || (!mealBreak?.meal_clock_in && !mealBreak?.meal_clock_out)}
              aria-label="Delete meal break"
            >
              <Close size="sm" aria-hidden="true" title="Delete meal break" />
            </Button>
          </Flex>
        )
      })}

      {!mealAllocation && (
        <Flex sx={{ alignItems: 'center', gap: 1, p: 1 }}>
          <span className="entity-row" style={{ whiteSpace: 'nowrap' }}>
            No break
          </span>
          <Button
            variant="text"
            iconOnly
            size="sm"
            type="button"
            onClick={handleAddMealBreak(1)}
            aria-label="Add meal break"
          >
            <Plus size="sm" aria-hidden="true" title="Add meal break" />
          </Button>
        </Flex>
      )}
    </Box>
  )
}
